import * as React from "react";
import { action } from "mobx";
import { observer, inject } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { sort } from "../../../utils/data";
import { ExperienceType, JobType, LookupType, EdType, AddExpRoute } from "../../../models/enums";
import { hashHistory } from "react-router";
import { ILocalization } from "../../../models/localization";
import  ProfileStore from "../../../stores/profileStore";
import { WorkExperience, EducationExperience, ActivityExperience, CCLCExperience } from "../../../models/profile";
import { Row, Col } from "react-flexbox-grid";
import { LookupValue } from "../../../models/lookup";
import Paper from "material-ui/Paper";
import FloatingAddBtn from "../../widgets/addBtn"; 
import Button from "material-ui/Button";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  withMobileDialog,
} from 'material-ui/Dialog';
import * as s from "./expSum.css";

@observer
class DeleteExperienceDlg extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    if (!this.props.store.profileStore.delExperience) {
      return null;
    }
    const msg: string = `${this.props.store.localization.fields.delRsrcDlg.question1} ${this.props.store.profileStore.delExperience.name} ${this.props.store.localization.fields.profile.fromSavedOps}`;
    return (<Dialog
      fullScreen={false}
      open={true}
      onClose={this.props.store.profileStore.clearDeleteExperience}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">{this.props.store.localization.fields.delRsrcDlg.title}</DialogTitle>
      <DialogContent>
        {msg} 
      </DialogContent>
      <DialogActions>
        <Button onClick={this.props.store.profileStore.clearDeleteExperience} color="secondary">{this.props.store.localization.fields.cancel}</Button>
        <Button onClick={this.props.store.profileStore.deleteExperience} color="secondary">{this.props.store.localization.fields.delete}</Button>
      </DialogActions>
    </Dialog>);
  }
}

@observer
export default class ExperienceSummary extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }

  @action update = (id: string): void => {
    this.props.store.profileStore.setAddExpRoute(AddExpRoute.Experience);
    hashHistory.push(`/profile/edit-experience/${id}`);
  }
  renderActionButtons = (expId: string, expType: ExperienceType, title:string): JSX.Element => {
    return (<div>
      <a className={s.linkText} onClick={() => this.update(expId)} >{this.props.store.localization.fields.editCCLC.update.toLowerCase()}</a>
      &nbsp;|&nbsp;
      <a className={s.linkText} onClick={() => this.props.store.profileStore.setDeleteExperience(expId, expType, title)}>{this.props.store.localization.fields.delete.toLowerCase()}</a>
    </div>);
  }
  renderSkillCount = (expId: string, type: ExperienceType, skillCt: number): JSX.Element => {
    const local: ILocalization = this.props.store.localization.fields;
    return <Col xs={2} sm={2} md={3}>
      <h4 className={s.number} onClick={() => this.props.store.profileStore.setSelectedExperience(expId, type)}>{skillCt}</h4>
      <p className={s.skillText}>{local.skillCount}</p>
    </Col>;
  }
  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const expRow: JSX.Element[] = [];
    const jobs: Array<WorkExperience> = this.props.store.profileStore.profile.jobs;
    const education: Array<EducationExperience> = this.props.store.profileStore.profile.educations;
    const activities: Array<ActivityExperience> = this.props.store.profileStore.profile.activities;
    sort(jobs, "position").map((j: WorkExperience, i: number): void => {
      if (j.expType === JobType.Work) {
        expRow.push(
          <Row key={"job-" + j.idHash} middle="xs" className={s.row}>
            <Col xs={2} lg={1} ><img src={local.icons.workExperience} className={s.expIcon} /></Col>
            <Col xs={8} md={7} lg={8} className={s.experience}>
              <p>{j.position}</p>
              <p className={s.employer}>{j.employer}</p>
              <p className={s.date}>{j.fromMon + "/" + j.fromYear + " - " + j.toMon + "/" + j.toYear}</p>
              {this.renderActionButtons(j.idHash, ExperienceType.Work, `${j.position} @ ${j.employer}`)}
            </Col>
            {this.renderSkillCount(j.idHash, ExperienceType.Work, j.skills.length)}
          </Row>);
        return;
      }
      if (j.expType === JobType.Military) {
        expRow.push(
          <Row key={"job-" + j.idHash} middle="xs" className={s.row}>
            <Col xs={2} lg={1} ><img src={local.icons.militaryExperience} className={s.expIcon} /></Col>
            <Col xs={8} md={7} lg={8} className={s.experience}>
              {this.props.store.localization.getLookup(LookupType.Services).map((service: LookupValue) => {
                if (service.order === j.service) {
                  return (<p key={"service-" + service.idHash}>{service.value}</p>)
                }
              })}
              <div className={s.military}>
                <p className={s.employer}>{j.mos}</p>
               </div>
              <p className={s.date}>{j.fromMon + "/" + j.fromYear + " - " + j.toMon + "/" + j.toYear}</p>
              {this.renderActionButtons(j.idHash, ExperienceType.Military, j.position)}
            </Col>
            {this.renderSkillCount(j.idHash, ExperienceType.Military, j.skills.length)}
          </Row>);
        return;
      }   
    })
    education.map((e: EducationExperience, i: number): void => {
      if (e.edType === EdType.Course) {
        const nm: string = e.courseTitle ? e.courseTitle : e.major ? e.major : null;
        expRow.push(
          <Row key={"edu-" + e.idHash} middle="xs" className={s.row}>
            <Col xs={2} lg={1} ><img src={local.icons.educationExperience} className={s.expIcon} /></Col>
            <Col xs={8} md={7} lg={8} className={s.experience}>
              <p>{nm}</p>
              <p className={s.date}>{`Completed ${e.toMon}/${e.toYear}`}</p>
              {this.renderActionButtons(e.idHash,ExperienceType.Course, nm)}
            </Col>
            {this.renderSkillCount(e.idHash, ExperienceType.Course, e.skills.length)}
          </Row>);
        return;
      } else if (e.edType === EdType.DegreeProgram) {
        const nm: string = e.name ? e.name : e.major ? e.major : "";
        expRow.push(
          <Row key={"edu-" + e.idHash} middle="xs" className={s.row}>
            <Col xs={2} lg={1} ><img src={local.icons.educationExperience} className={s.expIcon} /></Col>
            <Col xs={8} md={7} lg={8} className={s.experience}>
              <p className={s.schoolName}>{nm}</p>
              <p className={s.date}>{e.fromMon + "/" + e.fromYear + " - " + e.toMon + "/" + e.toYear}</p>
              {this.renderActionButtons(e.idHash, ExperienceType.GEDDegree, nm)}
            </Col>
            {this.renderSkillCount(e.idHash, ExperienceType.GEDDegree, e.skills.length)}
          </Row>);
        return;
      }   
    })

    activities.map((a: ActivityExperience, i: number): void => {
      expRow.push(
        <Row key={"act-" + a.idHash} middle="xs" className={s.row}>
          <Col xs={2} lg={1} ><img src={local.icons.lifeExperience} className={s.expIcon} /></Col>
          <Col xs={8} md={7} lg={8} className={s.experience}>
            <p>{a.role}</p>
            <p className={s.employer}>{a.org}</p>
            <p className={s.date}>{a.fromMon + "/" + a.fromYear + " - " + a.toMon + "/" + a.toYear}</p>
            {this.renderActionButtons(a.idHash, ExperienceType.Life, a.role)}
          </Col>
          {this.renderSkillCount(a.idHash, ExperienceType.Life, a.skills.length)}
        </Row>);
    });
   
    if (expRow.length === 0) {
      expRow.push(<p key="no-experience-summary" className={s.employer}>{local.profile.noExperiences}</p>)
    }

    return (<Row>
        <Row className={s.stretchRow}>
          <Col xs={12}>
            {expRow}
          </Col>
        </Row>
        <DeleteExperienceDlg store={this.props.store} />
      </Row>);
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/experienceSummary/index.tsx